/**
 * Parses root and selected folder ids from the Organize Stories and Folders URL.
 *
 * Path: `/stories/{entity}/folders/{rootFolderId}/organize/{selectedFolderId}`
 */

import { useMemo } from 'react';

const ORGANIZE_PATH_PATTERN = /\/stories\/[^/]+\/folders\/([^/]+)\/organize\/([^/]+)/;

export function parseOrganizeStoriesAndFoldersRoute(pathname: string): {
  rootFolderId: string | null;
  selectedFolderId: string | null;
} {
  const match = pathname.match(ORGANIZE_PATH_PATTERN);
  return {
    rootFolderId: match?.[1] ?? null,
    selectedFolderId: match?.[2] ?? null
  };
}

export function useOrganizeStoriesAndFoldersRoute(): {
  rootFolderId: string | null;
  selectedFolderId: string | null;
  currentFolderId: string | null;
} {
  const pathname = window.location.pathname;

  return useMemo(() => {
    const { rootFolderId, selectedFolderId } = parseOrganizeStoriesAndFoldersRoute(pathname);
    return {
      rootFolderId,
      selectedFolderId,
      currentFolderId: selectedFolderId
    };
  }, [pathname]);
}
